import { type ReactNode, useState } from 'react'

interface Tab {
  id: string;
  name: string | ReactNode;
  content: ReactNode | string;
  hidden?: boolean
}

interface TabMenuProps {
  defaultTab: string;
  tabs: Tab[];
}

const DEFAULT_CLASSES =
  'text-gray-500 hover:text-gray-700 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium hover:cursor-pointer'
const ACTIVE_CLASSES =
  'border-thatch-purple-secondary text-thatch-purple-secondary hover:text-thatch-purple-secondary'
const INACTIVE_CLASSES =
  'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'

export function TabMenu ({ defaultTab, tabs }: TabMenuProps) {
  const [activeTab, setActiveTab] = useState(defaultTab)

  const selectTab = (tabId: string) => {
    setActiveTab(tabId)
  }

  return (
    <>
      <div className='border-b border-gray-200'>
        <nav className='-mb-px flex space-x-8' aria-label='Tabs'>
          {tabs.filter(tab => !tab.hidden).map((tab) => (
            <div
              key={`menu-${tab.id}`}
              onClick={() => {
                selectTab(tab.id)
                const url = new URL(window.location.href)
                url.searchParams.set('tab', tab.id)
                window.history.pushState({}, '', url.toString())
              }}
              className={`${DEFAULT_CLASSES} ${
                activeTab === tab.id ? ACTIVE_CLASSES : INACTIVE_CLASSES
              }`}
            >
              {tab.name}
            </div>
          ))}
        </nav>
      </div>

      {tabs.map(
        (tab) =>
          activeTab === tab.id && (
            <div key={`section-${tab.id}`} className='w-full pt-4'>
              {tab.content}
            </div>
          )
      )}
    </>
  )
}

interface AnchorTab {
  id: string;
  name: string;
  url: string;
}

interface TabAnchormenuProps {
  tabs: AnchorTab[];
}

export function TabAnchorMenu ({ tabs }: TabAnchormenuProps) {
  return (
    <div className='border-b border-gray-200'>
      <nav className='-mb-px flex space-x-8' aria-label='Tabs'>
        {tabs.map((tab) => (
          <a
            key={tab.id}
            href={tab.url}
            className={`${DEFAULT_CLASSES} ${
              window.location.pathname === tab.url
                ? ACTIVE_CLASSES
                : INACTIVE_CLASSES
            }`}
          >
            {tab.name}
          </a>
        ))}
      </nav>
    </div>
  )
}
